











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ResponsavelWebhook} from '@/model/resource/ResponsavelWebhook'
import {ResponsavelWebhookCollection} from '@/model/collection/ResponsavelWebhookCollection'
import {ListResponsavelWebhookSchema} from '@/schema/resource/ResponsavelWebhook/ListResponsavelWebhookSchema'
import {CsvResponsavelWebhookSchema} from '@/schema/resource/ResponsavelWebhook/CsvResponsavelWebhookSchema'

@Component
export default class ListResponsavelWebhookView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelWebhookSchema()
  collection = new ResponsavelWebhookCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelWebhook) {
    Helper.pushByName('editResponsavelWebhook', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelWebhookCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelWebhook()
    new CsvResponsavelWebhookSchema().downloadCsv(csv.all())
  }
}
